/**
 * Verification utility functions for seller verification with Veriff
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const getStoredToken = () => {
  return localStorage.getItem('auth_token');
};

/**
 * Create a Veriff verification session
 * @returns {Promise<{data: {sessionId: string, url: string}, error: null} | {data: null, error: {message: string}}>}
 */
export const createVerificationSession = async () => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: { message: 'Not authenticated' } };
    }

    const response = await fetch(`${API_BASE_URL}/verification/create-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      return { data: null, error: { message: data.error || 'Failed to create verification session' } };
    }

    return { data, error: null };
  } catch (error) {
    return { data: null, error: { message: error.message || 'Network error' } };
  }
};

/**
 * Get current user's verification status
 * @returns {Promise<{data: {isSeller: boolean, status: string, sessionId: string, verifiedAt: string, sellerSince: string}, error: null} | {data: null, error: {message: string}}>}
 */
export const getVerificationStatus = async () => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: { message: 'Not authenticated' } };
    }

    const response = await fetch(`${API_BASE_URL}/verification/status`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      return { data: null, error: { message: data.error || 'Failed to fetch verification status' } };
    }

    return { data, error: null };
  } catch (error) {
    return { data: null, error: { message: error.message || 'Network error' } };
  }
};

